module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material"
  }, [_c('h2', [_vm._v("Location Details")]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "user_id",
      "options": _vm.initialUserOptions,
      "fetch-results": _vm.fetchUserResults
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Property / Depot name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.locationNotEditable,
      "type": "text",
      "placeholder": "Property / Depot name",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.streetNumber),
      expression: "streetNumber"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.locationNotEditable,
      "type": "text",
      "placeholder": "Number"
    },
    domProps: {
      "value": (_vm.streetNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.streetNumber = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-md-9"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.streetName),
      expression: "streetName"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Street Name",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.streetName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.streetName = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Suburb / Town")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.suburb),
      expression: "suburb"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Suburb / Town",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.suburb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.suburb = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('selectize', {
    staticClass: "form-control select2-material-placeholder",
    attrs: {
      "name": "state",
      "options": _vm.stateOptions,
      "disabled": _vm.locationNotEditable
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.locationNotEditable,
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("UHF Channel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uhfChannel),
      expression: "uhfChannel"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "UHF Channel",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.uhfChannel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uhfChannel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hours of loading")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hoursOfLoading),
      expression: "hoursOfLoading"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hours of loading",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.hoursOfLoading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hoursOfLoading = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("Access Instructions")]), _vm._v(" "), _c('location-photo', {
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  }, [(_vm.locationIsEditable) ? _c('ladda-button', {
    attrs: {
      "type": "danger",
      "on-click": _vm.handleDeletePhoto
    },
    slot: "delete"
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Text Directions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.directions),
      expression: "directions"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "placeholder": "Text Directions",
      "rows": "5",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.directions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.directions = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("Location Contact")]), _vm._v(" "), _c('div', {
    staticClass: "margin-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useContactDetails),
      expression: "useContactDetails"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-terms",
      "type": "checkbox",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "checked": Array.isArray(_vm.useContactDetails) ? _vm._i(_vm.useContactDetails, null) > -1 : (_vm.useContactDetails)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.useContactDetails,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.useContactDetails = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.useContactDetails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useContactDetails = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-terms"
    }
  }, [_vm._v("\n                    Use my contact details\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Primary Contact")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactName),
      expression: "contactName"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    class: {
      'empty': !_vm.useContactDetails
    },
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Secondary Contact")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryContactName),
      expression: "secondaryContactName"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    class: {
      'empty': !_vm.useContactDetails
    },
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.secondaryContactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryContactName = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Primary Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    class: {
      'empty': !_vm.useContactDetails
    },
    attrs: {
      "type": "text",
      "placeholder": "Primary Phone",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Secondary Phone (optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactSecondPhone),
      expression: "contactSecondPhone"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Secondary Phone (optional)",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.contactSecondPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactSecondPhone = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    class: {
      'empty': !_vm.useContactDetails
    },
    attrs: {
      "type": "text",
      "placeholder": "Email Address",
      "disabled": _vm.locationNotEditable
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('form', {
    staticClass: "form-material"
  }, [_c('location-map')], 1)])])])]), _vm._v(" "), (_vm.locationIsEditable) ? _c('div', [_c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'locations.index'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "type": "success",
      "on-click": _vm.handleSaveLocation
    }
  }, [_vm._v("Save Location")]), _vm._v(" "), (_vm.editingExistingLocation) ? _c('ladda-button', {
    attrs: {
      "type": "danger",
      "on-click": _vm.handleDelete
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-e91019d2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations/Form.vue
// module id = 1085
// module chunks = 0